import { useState } from "react";
import { useRepositoriesContext } from "../../contexts/RepositoriesContext";
import { CreateUserDto } from "../../core/models/dtos/CreateUserDto";
import { withToasts } from "../components/Toast/Toast";

export function useOrganizationUsers(organizationId: number, options?: { enabled?: boolean }) {
  const { userRepository } = useRepositoriesContext();
  const [isLoading, setIsLoading] = useState(false);

  const {
    data: users,
    isError: isUsersError,
    isLoading: isUsersLoading,
    isSuccess: isUsersSuccess,
  } = userRepository.useUsersOfOrganization(organizationId, options);

  function handleCreateUser(user: CreateUserDto) {
    async function transaction() {
      user.organizationId = organizationId;
      return await userRepository.createUser(user);
    }

    return withToasts(
      transaction,
      "Creating user",
      "User created",
      "Failed to create user",
      setIsLoading
    );
  }

  function handleDeleteUser(userId: number) {
    async function transaction() {
      return await userRepository.deleteUser(userId);
    }

    return withToasts(
      transaction,
      "Deleting user",
      "User deleted",
      "Failed to delete user",
      setIsLoading
    );
  }

  return {
    users: users || [],
    onCreateUser: handleCreateUser,
    onDeleteUser: handleDeleteUser,
    isLoading: isLoading || isUsersLoading,
    isError: isUsersError,
    isSuccess: isUsersSuccess
  };
}
